import mediaRunningReducer from "./mediaRunning/mediaRunning";

const rootReducers = {
  mediaRunning: mediaRunningReducer,
};

export default rootReducers;
